import React from 'react';
import styled from 'styled-components';
import Button from './Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service here
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorContent>
            <h1>Oops! Something went wrong.</h1>
            <p>We apologize for the inconvenience. Please try again later.</p>
            <Button 
              onClick={() => window.location.reload()} 
              variant="primary"
            >
              Refresh Page
            </Button>
          </ErrorContent>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  background-color: ${props => props.theme.colors.background.light};
`;

const ErrorContent = styled.div`
  text-align: center;
  max-width: 600px;

  h1 {
    color: ${props => props.theme.colors.primary};
    margin-bottom: ${props => props.theme.spacing.md};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.lg};
    color: ${props => props.theme.colors.text.secondary};
  }
`;

export default ErrorBoundary; 